!function() {
  "use strict";
  customElements.get("site-header") || customElements.define("site-header", class extends HTMLElement {
    limit=this.dataset.limit || 4;
    perform() {
      let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "header";
      t && (t.preventDefault(), t.stopPropagation());
      const s = encodeURIComponent(this.inputs[0]?.value);
      if (s) o = window.Shopify.routes.root + `search/suggest?q=${s}&resources[type]=query,product,collection,page,article&resources[options][prefix]=last&resources[options][unavailable_products]=last&resources[limit]=${this.limit}&resources[limit_scope]=each&section_id=${e}`; else var o = window.Shopify.routes.root + `?section_id=${e}`;
      this.results.classList.add("opacity-50", "cursor-wait"), document.body.classList.add("overflow-hidden"), 
      fetch(o).then((t => t.text())).then((t => {
        const s = (new DOMParser).parseFromString(t, "text/html").querySelector(`#shopify-section-${e}`);
        [ "[data-results]" ].forEach((t => {
          const e = this.querySelector(t);
          e && (e.innerHTML = s.querySelector(t).innerHTML);
        })), this.toggle.checked = !0;
      })).catch((t => {
        console.warn(t), this.querySelector("form").submit();
      })).finally((() => this.results.classList.remove("opacity-50", "cursor-wait")));
    }
    updateInputs() {
      let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      this.inputs.forEach((e => e.value = t));
    }
    syncInputs() {
      let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      this.inputs.forEach((e => {
        e !== t && (e.value = t.value);
      }));
    }
    constructor() {
      super();
    }
    connectedCallback() {
      this.inputs = this.querySelectorAll('[name="q"]'), this.results = this.querySelector("[data-results]"), 
      this.toggle = document.querySelector("#Search"), this.inputs.forEach((t => {
        t.addEventListener("input", (e => {
          this.syncInputs(t), Shopify.debounce(this.perform(e), 300);
        })), t.addEventListener("focus", (() => {
          this.toggle.checked = !0, document.body.classList.add("overflow-hidden");
        }));
      })), this.addEventListener("click", (t => {
        t.target.hasAttribute("data-suggestion") ? (t.preventDefault(), this.updateInputs(t.target.textContent), 
        this.perform()) : t.target.hasAttribute("data-view-all") ? this.inputs[0]?.closest("form")?.submit() : t.target.hasAttribute("data-search-close") && (t.stopPropagation(), 
        this.toggle.checked = !1, document.body.classList.remove("overflow-hidden"));
      }));
    }
  });
}();